import React from "react";

import { TWINT_LOGO } from "@constants/assets";
import { PAYMENT_OPTIONS } from "@constants/Bookings";
import { CONSTANTS } from "@constants/index";

export interface PaymentCardBadgeProps {
  brand?: string;
  className?: string;
  isHidden?: boolean;
  type?: string;
}

export const PaymentCardBadge: React.FC<PaymentCardBadgeProps> = ({
  brand,
  className = "me-3",
  isHidden = false,
  type,
}) => {
  const brandLower = (brand || "").toLowerCase();

  const isMastercard =
    brandLower.includes("master") || brandLower.includes("mc");

  const isVisa = brandLower.includes("visa");

  const isAmex = brandLower.includes("amex") || brandLower.includes("american");

  const isTwint =
    type?.toLowerCase() === CONSTANTS.CARD.TWINT_LOWER ||
    type === PAYMENT_OPTIONS.TWINT ||
    brandLower.includes("twint");

  if (isHidden && !isTwint) {
    return (
      <div
        className={`fg-payment-card-badge-hidden ${className}`}
        data-testid="payment-card-badge-hidden"
      >
        <span className="text-white fw-bold fg-badge-dots">
          {CONSTANTS.CARD.MASKED_DOTS}
        </span>
      </div>
    );
  }

  if (isTwint) {
    return (
      <div
        className={`fg-payment-card-badge card-type-twint ${className}`}
        data-testid="payment-card-badge"
      >
        <img
          src={TWINT_LOGO}
          alt="TWINT"
          className="fg-twint-badge-img"
          data-testid="twint-logo-img"
        />
      </div>
    );
  }

  if (isMastercard) {
    return (
      <div
        className={`fg-payment-card-badge card-type-mastercard ${className}`}
        data-testid="payment-card-badge"
      >
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="fg-chip" />
          <svg
            className="fg-mastercard-svg"
            width="22"
            height="14"
            viewBox="0 0 22 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Mastercard"
          >
            <circle cx="7" cy="7" r="7" fill="#EB001B" />
            <circle cx="15" cy="7" r="7" fill="#F79E1B" fillOpacity="0.92" />
          </svg>
        </div>
        <div className="fg-dots mt-auto">{CONSTANTS.CARD.DOTS}</div>
      </div>
    );
  }

  if (isVisa) {
    return (
      <div
        className={`fg-payment-card-badge card-type-visa ${className}`}
        data-testid="payment-card-badge"
      >
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="fg-chip" />
          <span className="fg-brand-visa">VISA</span>
        </div>
        <div className="fg-dots mt-auto">{CONSTANTS.CARD.DOTS}</div>
      </div>
    );
  }

  if (isAmex) {
    return (
      <div
        className={`fg-payment-card-badge card-type-amex ${className}`}
        data-testid="payment-card-badge"
      >
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="fg-chip" />
          <span className="fg-brand-amex">AMEX</span>
        </div>
        <div className="fg-dots mt-auto">{CONSTANTS.CARD.DOTS}</div>
      </div>
    );
  }

  return (
    <div
      className={`fg-payment-card-badge card-type-card ${className}`}
      data-testid="payment-card-badge"
    >
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="fg-chip" />
        <span className="fg-brand-logo">
          {CONSTANTS.CARD.DEFAULT_BRAND_UPPER}
        </span>
      </div>
      <div className="fg-dots mt-auto">{CONSTANTS.CARD.DOTS}</div>
    </div>
  );
};

export default PaymentCardBadge;
